import React from "react";
import { ChefHatIcon, MailIcon } from "lucide-react";
export function Footer() {
  return <footer className="w-full bg-ink py-12 text-cream" data-id="element-66" data-mp="3gfsoch60l2p3">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-5 text-center" data-id="element-67" data-mp="3ghc323c0v5or">
        <div className="flex items-center gap-2" data-id="element-68" data-mp="32pp601a99t4x">
          <ChefHatIcon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-69" data-mp="36oxwmxa01aw9" />
          <span className="font-display text-lg font-extrabold" data-id="element-70" data-mp="3uf0opddwyguv">MEGAPACK™ FRANQUICIA REPOSTERÍA</span>
        </div>
        <p className="max-w-md text-cream/70" data-id="element-71" data-mp="38h81hlebwon">
          El sistema N°1 para emprendedores en repostería de Latinoamérica.
        </p>
        <a href="mailto:tuoficiorentable0@gmail.com" className="inline-flex items-center gap-2 text-gold transition-colors duration-150 ease-out hover:text-gold-bright" data-id="element-72" data-mp="3ldkep6r0ggr6">
          <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="29ydxq3q81abh" />
          tuoficiorentable0@gmail.com
        </a>
        <p className="border-t border-ink-line pt-5 text-sm text-cream/50" data-id="element-74" data-mp="2ezutxlxrg8lq">
          © MegaPack Franquicia Repostería™ — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}